import { useState } from 'react';
import { battles } from '@/mocks/chigua';

function fmt(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;
}

export default function PKShowdown() {
  const [my, setMy] = useState<Record<number, 'L' | 'R'>>({});
  const [extra, setExtra] = useState<Record<number, 'L' | 'R'>>({});

  const vote = (battleId: number, side: 'L' | 'R') => {
    setExtra((p) => ({ ...p, [battleId]: side }));
  };

  return (
    <section id="pk" className="w-full bg-gradient-to-b from-melon-50 to-canvas py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-leaf-600 uppercase">
            <i className="ri-swap-box-fill"></i> Battle Zone
          </span>
          <h2 className="mt-3 font-display font-bold text-3xl md:text-5xl text-ink">热门人气 · 面对面PK</h2>
          <p className="mt-3 text-sm md:text-base text-ink/60">
            势均力敌的选手同台较量，实时显示两方票数对比。支持你喜欢的一方，助 TA 赢下这一轮。
          </p>
        </div>

        <div className="mt-10 space-y-6">
          {battles.map((b) => {
            const lv = b.left.votes + (extra[b.id] === 'L' ? 1 : 0);
            const rv = b.right.votes + (extra[b.id] === 'R' ? 1 : 0);
            const total = lv + rv;
            const lp = (lv / total) * 100;
            const chosen = my[b.id];
            return (
              <article key={b.id} className="rounded-2xl bg-white border border-melon-100 p-5 md:p-7 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-flex items-center gap-1.5 text-sm font-bold text-melon-600 bg-melon-50 px-3 py-1 rounded-full">
                    <i className="ri-vip-crown-2-line"></i>{b.title}
                  </span>
                  <span className="text-xs text-ink/40 hidden sm:block">PK 剩余时间 02:41:35</span>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_1fr] gap-5 items-stretch">
                  <button
                    onClick={() => { vote(b.id, 'L'); setMy((p) => ({ ...p, [b.id]: 'L' })); }}
                    className={`text-left rounded-2xl p-4 flex items-center gap-4 transition-all cursor-pointer ${chosen === 'L' ? 'ring-2 ring-melon-500 bg-melon-50' : 'bg-canvas hover:bg-melon-50'}`}
                  >
                    <img src={b.left.avatar} alt={`${b.left.name}的PK头像`} className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover shrink-0" />
                    <div className="min-w-0">
                      <h3 className="font-display font-bold text-lg text-ink truncate">{b.left.name}</h3>
                      <p className="text-xs text-ink/55 truncate">{b.left.tagline}</p>
                      <p className="mt-1 font-display font-bold text-melon-600 text-lg">{fmt(lv)}</p>
                    </div>
                  </button>

                  <div className="flex items-center justify-center">
                    <span className="font-display font-extrabold text-ink/20 text-4xl">VS</span>
                  </div>

                  <button
                    onClick={() => { vote(b.id, 'R'); setMy((p) => ({ ...p, [b.id]: 'R' })); }}
                    className={`text-right rounded-2xl p-4 flex items-center justify-end gap-4 transition-all cursor-pointer ${chosen === 'R' ? 'ring-2 ring-leaf-500 bg-leaf-50' : 'bg-canvas hover:bg-leaf-50'}`}
                  >
                    <div className="min-w-0">
                      <h3 className="font-display font-bold text-lg text-ink truncate">{b.right.name}</h3>
                      <p className="text-xs text-ink/55 truncate">{b.right.tagline}</p>
                      <p className="mt-1 font-display font-bold text-leaf-600 text-lg">{fmt(rv)}</p>
                    </div>
                    <img src={b.right.avatar} alt={`${b.right.name}的PK头像`} className="w-16 h-16 md:w-20 md:h-20 rounded-2xl object-cover shrink-0" />
                  </button>
                </div>

                <div className="mt-4 flex gap-0 h-3 rounded-full overflow-hidden">
                  <div className="bg-gradient-to-r from-melon-400 to-melon-500 transition-all duration-500" style={{ width: `${lp}%` }}></div>
                  <div className="bg-gradient-to-r from-leaf-500 to-leaf-400 transition-all duration-500" style={{ width: `${100 - lp}%` }}></div>
                </div>
                <div className="mt-1.5 flex justify-between text-xs font-semibold">
                  <span className="text-melon-600">左方领先 {lp.toFixed(1)}%</span>
                  <span className="text-leaf-600">{chosen ? `我已支持 ${chosen === 'L' ? b.left.name : b.right.name}` : '点击左右卡片选择支持方'}</span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}